define([
	"dojo/_base/declare",
	"csi/heading/TextController",
	"SiteAdmin/Locale"
], function(declare,TextController,Locale) {

	return declare(TextController, {
		toWriter: function() {
			// summary: write operation to set resource for enum
			Locale.setResource(this.m_writer, Locale.ATTR_RESOURCES, [this.ren._getEnumValue(this._ctx)], this.newValue);
		}
	});
});